import { render, staticRenderFns } from "./AgendaIndex.vue?vue&type=template&id=28f51f89&scoped=true&"
import script from "./AgendaIndex.vue?vue&type=script&lang=ts&"
export * from "./AgendaIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f51f89",
  null
  
)

export default component.exports